export default "__VITE_ASSET__BXg9J8fT__"